var $2b6dc66a63a162db$exports = {};
function $2b6dc66a63a162db$var$isPdfLink(link) {
    const href = link.getAttribute("href");
    return href && /\.pdf(?:$|[?#])/i.test(href);
}
function $2b6dc66a63a162db$var$getPdfUrl(link) {
    const url = new URL(link.getAttribute("href"), document.baseURI);
    url.hash = "";
    return url;
}
function $2b6dc66a63a162db$var$getPdfFileName(url) {
    const segments = url.pathname.split("/");
    return decodeURIComponent(segments[segments.length - 1]);
}
function $2b6dc66a63a162db$var$viewerUrl(pdfUrl) {
    return `${pdfUrl.href}#view=FitH&toolbar=0&navpanes=0`;
}
function $2b6dc66a63a162db$var$createSlideshow(pdfUrl) {
    const slideshow = document.createElement("div");
    slideshow.className = "pdf-slideshow";
    const frame = document.createElement("iframe");
    frame.className = "pdf-slideshow__frame";
    frame.loading = "lazy";
    frame.src = $2b6dc66a63a162db$var$viewerUrl(pdfUrl);
    frame.title = `Vista de ${$2b6dc66a63a162db$var$getPdfFileName(pdfUrl)}`;
    slideshow.append(frame);
    return slideshow;
}
function $2b6dc66a63a162db$var$attachSlideshows() {
    document.querySelectorAll("a[href]").forEach((link)=>{
        if (!$2b6dc66a63a162db$var$isPdfLink(link) || link.dataset.pdfSlideshowReady === "true") return;
        const pdfUrl = $2b6dc66a63a162db$var$getPdfUrl(link);
        const host = link.closest("li") || link.parentElement;
        if (!host) return;
        link.dataset.pdfSlideshowReady = "true";
        host.appendChild($2b6dc66a63a162db$var$createSlideshow(pdfUrl));
    });
}
document.addEventListener("DOMContentLoaded", $2b6dc66a63a162db$var$attachSlideshows);


//# sourceMappingURL=eventos.84f67943.js.map
